class Sgd {
    constructor({ _id, title, data }) {
      this.id = _id;
      this.title = title;
      this.data = data;
    }
  }
  
  export default Sgd;
  